import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  PlainSelectionsReducer,
} from './common.js';

const SelectTextSelectionsReducer = PlainSelectionsReducer;

const SelectTextSelectionsAggregator = ({ question, responses }) =>
  (responses || []).reduce((acc, response) => {
    const { tokens } = question || {};
    const { data } = response || {};
    const { selectedTokens } = data || {};

    if (!selectedTokens || !selectedTokens.length) return acc;

    (selectedTokens || []).forEach(selectedToken => {
      const identifier = `${selectedToken.start}__${selectedToken.end}`;
      const currentToken = (tokens || []).find(
        ({ start, end }) =>
          start === selectedToken.start && end === selectedToken.end
      );

      if (!acc[identifier]) {
        acc[identifier] = {
          count: 0,
          value: currentToken && currentToken.text,
        };
      }

      acc[identifier].count += 1;
    });

    return acc;
  }, {});

export default {
  AggregateMap: GlobalAggregateMap(SelectTextSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(SelectTextSelectionsReducer),
};
